/* Grind preference picker.
 *
 * Shows the optional brew-method dropdown only when a "ground" value is selected in the
 * whole/ground control it sits beside. Markup comes from snippets/bb-grind-preference.liquid.
 *
 * This lives in an asset rather than inline in the product form because inline <script>
 * inside the /cart/add form is stripped before it reaches the DOM on this theme.
 *
 * The field is a line item property (properties[Grind for]), so a blank value is dropped
 * by Shopify and templates/cart.liquid already skips blank properties.
 */
(function () {
  'use strict';

  function isGround(value) {
    return String(value || '').toLowerCase().indexOf('ground') !== -1;
  }

  /* Read the current value of the whole/ground control sharing this row. */
  function selectedGrind(pref) {
    var row = pref.parentNode;
    if (!row) return null;
    var checked = row.querySelector('.variant-input-wrap input[type="radio"]:checked');
    if (checked) return checked.value;
    var drop = row.querySelector('.variant-wrapper select');
    if (drop) return drop.value;
    return null;
  }

  function sync(pref) {
    var select = pref.querySelector('[data-bb-grind-select]');
    if (!select) return;

    var value = selectedGrind(pref);
    /* null means the control could not be read, so fail open and show the field rather
       than silently hiding an option the customer may want. */
    var show = value === null ? true : isGround(value);

    if (show) {
      pref.classList.add('is-visible');
      select.disabled = false;
    } else {
      pref.classList.remove('is-visible');
      /* Reset and disable so a preference chosen while on Ground can never ride along
         on a Whole Bean order. Disabled controls are not submitted. */
      select.value = '';
      select.disabled = true;
    }
    select.classList.toggle('has-value', !!select.value);
  }

  function bindAll() {
    var prefs = document.querySelectorAll('[data-bb-grind-pref]');

    for (var i = 0; i < prefs.length; i++) {
      (function (pref) {
        if (pref.getAttribute('data-bb-bound')) {
          sync(pref);
          return;
        }
        pref.setAttribute('data-bb-bound', '1');

        var form = pref.closest ? pref.closest('form[action*="/cart/add"]') : null;
        var scope = form || document;

        /* Delegated, so it survives the theme re-rendering the option buttons. */
        scope.addEventListener('change', function (e) {
          var t = e.target;
          if (!t) return;
          if (t.hasAttribute && t.hasAttribute('data-bb-grind-select')) {
            t.classList.toggle('has-value', !!t.value);
            return;
          }
          sync(pref);
        });

        scope.addEventListener('click', function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          /* Label clicks land before the radio updates, so defer a tick. */
          if (t.closest('.variant-input')) {
            setTimeout(function () { sync(pref); }, 0);
          }
        });

        sync(pref);
      })(prefs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  /* Some themes swap product markup on variant change; re-bind defensively. */
  document.addEventListener('variant:changed', bindAll);
  document.addEventListener('variantChange', bindAll);
})();
